import React from 'react';

import { Avatar, makeStyles, Tooltip, Typography } from '@gogame/components';
import { useSocket } from '@gogame/sockets';

import { useSocketConnectedUsers } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Socket/hooks';

const useStyles = makeStyles((theme) => {
  return {
    avatar: {
      background: theme.palette.common.white,
      border: ({ color }) => `2px solid ${color}`,
      color: ({ color }) => color,
      marginLeft: '-24px',
    },
  };
});
export const ConnectedUser = ({ user, color }) => {
  const classes = useStyles({ color });
  return (
    <Tooltip title={user?.name} wrapper wrapperComponent={'div'}>
      <Avatar alt={user?.initials} className={classes.avatar}>
        <Typography variant={'body2'}>{user?.initials}</Typography>
      </Avatar>
    </Tooltip>
  );
};

export const ConnectedAvatars = () => {
  const socket = useSocket();
  const connectedUsers = useSocketConnectedUsers();

  const otherConnection = connectedUsers.filter(
    (connection) => connection.id !== socket.id && connection.user
  );

  return (
    <React.Fragment>
      {otherConnection.map(({ user }, index) => (
        <ConnectedUser key={index} user={user} color={user.color} />
      ))}
    </React.Fragment>
  );
};
